import {
    createLoadingSpinner,
    LoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
} from '@vfde-brix/ws10/loading-spinner';
import { startAppListening } from 'Container/App/listener';
import { selectLoading } from 'Container/App/selectors';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { LOADING_INDICATOR_CSS_SELECTOR } from 'Container/App/constants';

/**
 * Mount loading spinner
 */
export const mountLoadingSpinner = (): LoadingSpinner | null => {
    const loadingSpinner = createComponentById(createLoadingSpinner, LOADING_INDICATOR_CSS_SELECTOR, {
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectLoading(currentState) !== selectLoading(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const isLoading = selectLoading(api.getState());

            loadingSpinner?.toggle(isLoading);
        },
    });

    return loadingSpinner;
};
